import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey } from '../../query/types';

const widgetsKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys] as const,
    getStarted: [...keys, 'getStarted'] as const,
    openTasks: [...keys, 'openTasks'] as const,
    quickLinks: [...keys, 'quickLinks'] as const,
    salesMetrics: [...keys, 'salesMetrics'] as const,
    topProducts: [...keys, 'topProducts'] as const,
    productFulfillment: [...keys, 'productFulfillment'] as const,
    memberships: [...keys, 'memberships'] as const,
    supporterStats: [...keys, 'supporterStats'] as const,
    events: [...keys, 'events'] as const,
    library: [...keys, 'library'] as const,
    recentOrders: [...keys, 'recentOrders'] as const,
  });

export { widgetsKeys };
